import { SPI, FormIntegerFieldWidget, ViewType, ModelFieldType, FormFieldWidget } from '@kunlun/dependencies';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: [ViewType.Form, ViewType.Search],
    ttype: [ModelFieldType.Integer],
    multi: false,
    name: 'sellingStoreCount',
    model: 'deli.aries.settlement.DeliAriesCmActivityItem'
  })
)
export class FormIntegerSellingStoreCountFieldWidget extends FormIntegerFieldWidget {
  public initialize(props) {
    super.initialize(props);
    return this;
  }

  public change(value) {
    const numValue = Number(value);
    if (!isNaN(numValue) && numValue > 99999) {
      super.change(99999);
    } else {
      super.change(value);
    }
  }
}
